import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import DashboardScreen from './screens/DashboardScreen';
import CreateHPTScreen from './screens/CreateHPTScreen';
import DetailsHPTScreen from './screens/DetailsHPTScreen';
import EditHPTScreen from './screens/EditHPTScreen';
import DetailsPTWScreen from './screens/DetailsPTWScreen';
import CreatePTWDirectoScreen from './screens/CreatePTWDirectoScreen';
import axios from 'axios';
import PlanificadorScreen from './screens/PlanificadorScreen';
import PermisoPlataforma from './components/PermisoPlataforma'
import PermisoQuimicos from './components/PermisoQuimicos';
import PermisoCarretilla from './components/PermisoCarretilla';
import PermisoEscalera from './components/PermisoEscalera';
import PermisoEspaciosConfinados from './components/PermisoEspaciosConfinados';
import CreateTemplateScreen from './screens/CreateTemplateScreen';


// ============================================================================
// Comprobación de sesion caducada
// ============================================================================
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("⏳ Sesión caducada. Cerrando sesión por seguridad...");
            localStorage.removeItem('userToken');
            window.location.href = '/login'; 
        }
        return Promise.reject(error);
    }
);

// Componente para proteger rutas (Solo entras si hay Token)
const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('userToken');
    return token ? children : <Navigate to="/login" />;
};


function App() {
    return (
        <Router>
            <Routes>
                {/* Ruta Pública */}
                <Route path="/login" element={<LoginScreen />} />

                {/* Rutas Privadas */}
                <Route
                    path="/dashboard"
                    element={<PrivateRoute><DashboardScreen /></PrivateRoute>}
                />
                <Route
                    path="/crear-hpt"
                    element={<PrivateRoute><CreateHPTScreen /></PrivateRoute>}
                />
                <Route
                    path="/detalles-hpt/:id"
                    element={<PrivateRoute><DetailsHPTScreen /></PrivateRoute>}
                />
                <Route
                    path="/editar-hpt/:id"
                    element={<PrivateRoute><EditHPTScreen /></PrivateRoute>}
                />
                <Route
                    path="/detalles-ptw/:id"
                    element={<PrivateRoute><DetailsPTWScreen /></PrivateRoute>}
                />
                <Route
                    path="/crear-ptw-directo"
                    element={<PrivateRoute><CreatePTWDirectoScreen /></PrivateRoute>}
                />
                <Route
                    path="/solicitud-plataforma"
                    element={<PrivateRoute><PermisoPlataforma/></PrivateRoute>}
                />
                <Route
                    path="/solicitud-carretilla"
                    element={<PrivateRoute><PermisoCarretilla/></PrivateRoute>}
                />
                <Route
                    path="/solicitud-quimico"
                    element={<PrivateRoute><PermisoQuimicos/></PrivateRoute>}
                />
                <Route
                    path="/solicitud-confinados"
                    element={<PrivateRoute><PermisoEspaciosConfinados/></PrivateRoute>}
                />
                <Route
                    path="/solicitud-escalera"
                    element={<PrivateRoute><PermisoEscalera/></PrivateRoute>}
                />

                <Route path="/solicitud-escalera/:id" element={<PermisoEscalera />} />
                <Route path="/solicitud-plataforma/:id" element={<PermisoPlataforma />} />
                <Route path="/solicitud-quimico/:id" element={<PermisoQuimicos />} />
                <Route path="/solicitud-carretilla/:id" element={<PermisoCarretilla />} />
                <Route path="/solicitud-confinados/:id" element={<PermisoEspaciosConfinados />} />
                <Route path="/crear-plantilla" element={<CreateTemplateScreen />} />

                <Route path="/planificador" element={<PlanificadorScreen />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    );
}

export default App;